import { FC } from 'react';
import { CodeField, ICodeFieldProps } from './CodeField';

export interface ICodeFieldContainerProps extends ICodeFieldProps {

}

export const CodeFieldContainer: FC<ICodeFieldContainerProps> = (props) => {
  return (
    <CodeField
      {...props}
    />
  );
};
